export default "__VITE_ASSET__DSchlbKy__"